import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './AgendaRecursos.scss';

class AgendaRecursos extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
	}

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Agenda ANBIMA de Gestão de Recursos - {texts.title}</title>
        </Helmet>

        <div className="agenda-recursos-home page-gradient page-gradient--yellow bg-gray" ref="agenda-recursos-home">

          <section className="agenda-recursos-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink to="/estrategias/para-o-mercado" className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">
														<span className="gri_text gri_text--fixed">
                              Agenda ANBIMA<br />de Gestão de Recursos
															<span className="gri_label gray">GRI <b>203-2</b></span>
														</span>
                          </h1>
                        </div>
                        <div className="card__content__body">
                          <p className="gri_text">
                            Mostrar como o fortalecimento da indústria de gestão de recursos pode trazer benefícios socioeconômicos para o país: esse foi o nosso objetivo ao lançar a agenda <a href="https://www.anbima.com.br/email/newsletter/Agenda-Anbima-2019/index.htm" target="_blank" className="text_link text_link--yellow text_link--no-underline">Gestão de recursos: uma visão para o desenvolvimento</a>. O estudo mostra que, em cinco anos, o aumento da base de ativos poderia contribuir para alcançarmos:  
                          </p>
                          <div className="columns row">

                            <div className="col-4">
                              <h3>402 mil</h3>
                              <p>novos empregos</p>
                            </div>

                            <div className="col-4">
                              <p>incremento de</p>
                              <h3>1,36%</h3>
                              <p>no PIB</p>
                            </div>

                            <div className="col-4">
                              <p>arrecadação de</p>
                              <h3>1,52%</h3>
                              <p>mais impostos</p>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.para_o_mercado.agenda_recursos.bg_card} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="agenda-recursos-body">

            <div className="container container--large">
              <div className="row">
								
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border card--para-o-mercado">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title title--small yellow">O estudo também identifica as tendências internacionais para a indústria de gestão de recursos e os desafios que elas impõem ao mercado brasileiro:</h3>
                        </div>

                        <div className="card__content__body">

                          <ul className="bullets bullets--yellow">
                            <li><b>Migração</b> das aplicações para ativos de maior valor agregado;</li>
                            <li><b>Protagonismo</b> dos investidores na tomada de decisão;</li>
                            <li><b>Crescimento</b> do uso de canais digitais;</li>
                            <li><b>Uso</b> do suitability (análise do perfil do investidor) como diferencial competitivo;</li>
                            <li><b>Inovação e tecnologia</b> para melhorar a eficiência da indústria.</li>
                          </ul>

                          <p>
                            A partir dessas tendências, o documento lista medidas necessárias para atender a cada um dos desafios apresentados. A Agenda ANBIMA para o Desenvolvimento da Indústria de Gestão de Investimentos inclui ajustes de caráter regulatório e autorregulatório, além de iniciativas institucionais de fomento ao setor. 
                            <a href="https://www.anbima.com.br/email/newsletter/Agenda-Anbima-2019/index.htm" target="_blank" className="text_link text_link--yellow text_link--no-underline">Confira o material completo</a>.
                          </p>

                          <img src={images.para_o_mercado.grafico_gestao} className="grafico_gestao" />
                          
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

              </div>
            </div>

          </section>

        </div>
      </div>
    );
  }
}

export { AgendaRecursos };
